import { EVENT_TYPES } from "../candidate-details/data"
import { formatLeadAddress } from "./leadList"

const HISTORY_TYPE_TO_EVENT = {
  call: EVENT_TYPES.call,
  sms: EVENT_TYPES.sms,
  email: EVENT_TYPES.email,
}

function smsTransactionFromHistoryItem(item) {
  return {
    id: item.transaction_id ?? item.id,
    created: item.created,
    text: item.detail || "",
    direction: item.message_direction || item.direction || "outgoing",
  }
}

function mapEmailHistoryItem(item) {
  const type = EVENT_TYPES.email
  const id = item.source_id != null ? item.source_id : item.id
  return {
    ...item,
    type,
    id,
    created: item.created,
    campaign: {
      name: item.title || "Email",
      rendered_body: item.detail || "",
    },
    subject: item.detail || item.title || "",
    transactions: item.transactions || [],
  }
}

export function mapLeadHistoryToCrmEvents(historyItems = []) {
  const smsBySource = new Map()
  const ordered = []

  for (const item of historyItems) {
    const type = HISTORY_TYPE_TO_EVENT[item.activity_type] || item.activity_type
    if (type === EVENT_TYPES.sms) {
      const sourceId = item.source_id != null ? item.source_id : item.id
      const key = String(sourceId)
      if (!smsBySource.has(key)) {
        smsBySource.set(key, {
          ...item,
          type: EVENT_TYPES.sms,
          id: sourceId,
          created: item.created,
          campaign: { name: item.title || "SMS" },
          transactions: [],
        })
        ordered.push({ kind: "sms", key })
      }
      const grouped = smsBySource.get(key)
      grouped.transactions.push(smsTransactionFromHistoryItem(item))
      if (item.created && item.created < grouped.created) {
        grouped.created = item.created
      }
      continue
    }
    if (type === EVENT_TYPES.email) {
      ordered.push({ kind: "event", event: mapEmailHistoryItem(item) })
      continue
    }
    const id = item.source_id != null ? item.source_id : item.id
    ordered.push({
      kind: "event",
      event: { ...item, type, id, created: item.created },
    })
  }

  return ordered.map((entry) =>
    entry.kind === "sms" ? smsBySource.get(entry.key) : entry.event
  )
}

export function mergeCrmEvents(candidateEvents = [], leadEvents = []) {
  const seen = new Set()
  const out = []
  for (const event of [...candidateEvents, ...leadEvents]) {
    if (!event) continue
    const key = `${event.type}-${event.id}`
    if (seen.has(key)) continue
    seen.add(key)
    out.push(event)
  }
  return out
}

export function mapLeadToCandidateViewModel(
  lead,
  leadSource,
  candidateDetails = null
) {
  const leadIdentity = {
    lead_source: leadSource,
    lead_ref_id: lead.id,
  }
  if (candidateDetails) {
    return {
      ...candidateDetails,
      ...leadIdentity,
      is_dnc: Boolean(lead.is_dnc),
    }
  }
  return {
    id: null,
    candidate_name: lead.name || "",
    company_name: lead.office_name || "",
    profile_image: null,
    email: lead.email || "",
    phone: lead.phone || "",
    address: formatLeadAddress(lead),
    website: lead.website || "",
    notes: lead.notes || "",
    facebook_link: lead.facebook_link || "",
    linkedin_link: lead.linkedin_link || "",
    instagram_link: lead.instagram_link || "",
    years_in_business: lead.years_in_business ?? null,
    sales_volume_last_year: lead.total_production ?? null,
    homes_sold_last_year: lead.total_transactions_count ?? null,
    annual_value: lead.annual_value ?? null,
    likelihood_to_move: lead.likelihood_to_move ?? null,
    rating: lead.rating ?? null,
    custom_tags: lead.custom_tags ?? [],
    crm_events: [],
    crm_stage: {},
    feedback: null,
    ssot_agent_id: leadSource === "mls" ? lead.id : null,
    imported: Boolean(lead.imported),
    candidate_id: lead.candidate_id ?? null,
    is_dnc: Boolean(lead.is_dnc),
    ...leadIdentity,
  }
}
